import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import './XeroCallback.css';

function XeroCallback() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');
  const tenantId = searchParams.get('tenant_id');
  const tenantName = searchParams.get('tenant_name');
  const message = searchParams.get('message');

  useEffect(() => {
    // Send message to parent window (the Xero page that opened this popup)
    const result = {
      status,
      tenantId,
      tenantName,
      message: message ? decodeURIComponent(message) : undefined,
    };

    // Post message to parent window
    if (window.opener) {
      window.opener.postMessage(
        {
          type: 'XERO_AUTH_RESULT',
          ...result,
        },
        window.location.origin
      );
    }

    // Close the popup after a short delay to allow message to be sent
    setTimeout(() => {
      window.close();
    }, 500);
  }, [status, tenantId, tenantName, message]);

  return (
    <div className="xero-callback">
      <div className="callback-content">
        {status === 'success' ? (
          <>
            <div className="callback-icon success">✓</div>
            <h2>Connection Successful!</h2>
            <p>Your Xero account has been connected successfully.</p>
            {tenantName && <p className="tenant-name">Connected to: {tenantName}</p>}
            <p className="callback-hint">This window will close automatically...</p>
          </>
        ) : (
          <>
            <div className="callback-icon error">✗</div>
            <h2>Connection Failed</h2>
            <p>{message ? decodeURIComponent(message) : 'An error occurred while connecting to Xero.'}</p>
            <p className="callback-hint">This window will close automatically...</p>
          </>
        )}
      </div>
    </div>
  );
}

export default XeroCallback;

